import { CStatusIndicator, formatDate, trimNumber, TStatusIndicator } from "@ts/ui-models";
import moment from "moment";


export const sortIndicatorsByName = (list: CStatusIndicator[]): CStatusIndicator[] =>
    [...list].sort((a, b) => {
        const nameA = (a.name ?? '').toString();
        const nameB = (b.name ?? '').toString();
        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
    });

/**
 * Helpers puros (fuera del componente) => más testables y más legibles
 */
export function formatIndicatorValue(indicator: TStatusIndicator): string | number {
    const value = (indicator as any).value;
    const type = (indicator as any).type as string | undefined;

    if (value === undefined || value === null) return '';

    switch (type) {
        case 'time':
            return value instanceof Date ? moment(value).format('HH:mmZ') : String(value);

        case 'date':
            return value instanceof Date ? moment(value).format('DD/MM/YYYY') : String(value);

        case 'timestamp':
            return value instanceof Date ? formatDate(value) : String(value);

        case 'integer': {
            const n = typeof value === 'number' ? value : parseInt(String(value), 10);
            return Number.isFinite(n) ? n : String(value);
        }

        case 'float': {
            const n = parseFloat(String(value));
            return Number.isFinite(n) ? trimNumber(n) : String(value);
        }

        default:
            // Si es un objeto/array, lo mostramos estable (sin petar)
            try {
                return typeof value === 'string' || typeof value === 'number' ? value : JSON.stringify(value);
            } catch {
                return String(value);
            }
    }
}

export function formatSourceLabel(
    source: TStatusIndicator['source'],
    t: (k: string) => string
): string {
    if (!source || typeof source !== 'object') return '';

    switch (source.type) {
        case 'user': {
            const person = source.data?.userPersonData;
            if (!person) return '';
            const firstName = person.firstName ?? '';
            const familyName = person.familyName ?? '';
            const fullName = `${firstName} ${familyName}`.trim();
            return fullName ? `${t('User')}: ${fullName}` : '';
        }

        case 'event': {
            const data = source.data;
            const label = data?.description ?? data?.name ?? data?.logicalId ?? '';
            return label ? `${t('Event')}: ${label}` : '';
        }

        case 'deliverychain':
        case 'deliveryChain': {
            const data = source.data;
            const label = data?.name ?? '';
            return label ? `${t('Delivery chain')}: ${label}` : '';
        }

        default:
            return '';
    }
}

export function formatMaybeDate(value: any): string {
    if (!value) return '';
    return formatDate(value);
}
